module.exports = __webpack_public_path__ + "img/fiber.d4d445d3.jpg";